module.exports = __webpack_public_path__ + "img/image_4.2f5bcec6.jpg";